// noinspection JSUnresolvedVariable

import moment from 'moment';

// @vue/component
export default {
  name: 'PromotionCodesListItem',

  props: {
    code: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      settingsByStatus: {
        active: {
          status: {
            name: 'Aktywny',
            color: '#8DC63F',
          },
          button: {
            backgroundColor: '#F6A821',
            color: '#393C45',
            text: 'Aktywny',
          },
        },
        waiting: {
          status: {
            name: 'Oczekujący',
            color: '#F6A821',
          },
          button: {
            backgroundColor: '#FFFFFF',
            color: '#393C45',
            text: 'Aktywuj',
          },
        },
        used: {
          status: {
            name: 'Wykorzystany',
            color: '#DB524B',
          },
          button: {
            backgroundColor: '#9C9EA2',
            color: '#393C45',
            text: 'Aktywny',
          },
        },
      },
    };
  },

  computed: {
    isActive() {
      return this.code.is_active;
    },
    wasUsed() {
      return this.code.was_used;
    },
    expiredDate() {
      if (this.code.expired_days === 0) return this.code.active_date_to;
      return moment(this.code.created_at).add(this.code.expired_days, 'days');
    },
    status() {
      if (this.code.is_active) return 'active';
      return this.code.was_used ? 'used' : 'waiting';
    },
  },

  methods: {
    async handleActivateCode() {
      if (this.isActive || this.was_used) return;

      const isSuccess = await this.$store.dispatch('promotionCodes/edit', { code: this.code.name.toUpperCase() });
      await this.$store.dispatch('promotionCodes/getList');
      if (isSuccess) {
        this.$notify.success({
          title: 'Aktywacja kodu',
          message: `Aktywowano kod: ${this.code.name.toUpperCase()}`,
          customClass: 'callmeweb-notification',
        });
      } else {
        this.$notify.error({
          title: 'Aktywacja kodu',
          message: 'Kod nie został aktywowany',
          customClass: 'callmeweb-notification',
        });
      }
    },
  },
};
